// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"488":"f8d30e51","670":"b87bbe11","796":"27d79406","832":"2205e162","849":"3c4b331c","856":"e9941db7"}[chunkId] + ".chunk.css";
};